// @ts-expect-error untyped file
import WidgetErrorRetryPanel from './WidgetErrorRetryPanel';
// @ts-expect-error untyped file
import AsyncComponentErrorBoundary from '../code-splitting/AsyncComponentErrorBoundary';
// @ts-expect-error untyped file
import CurrentViewContainer from '../current-view/CurrentViewContainer';
import { useAccessibilityContext } from 'conversations-visitor-message-history/accessibility/AccessibilityContext';
import { Fragment } from 'react';
import DialogWindow from './DialogWindow';
import { jsx as _jsx } from "react/jsx-runtime";
const WidgetWindow = props => {
  const {
    inline,
    isOpen,
    shouldRenderDialog,
    mobile,
    widgetLocation,
    onClose,
    onOpenAnimationStarted,
    onCloseAnimationFinished,
    onOpenAnimationFinished,
    onCloseAnimationStarted
  } = props;
  const {
    disableWidgetDialog
  } = useAccessibilityContext();
  const hideDialog = disableWidgetDialog || !shouldRenderDialog;
  const Wrapper = hideDialog ? Fragment : DialogWindow;
  const wrapperProps = hideDialog ? {} : {
    isOpen,
    onClose
  };
  return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, wrapperProps, {
    children: /*#__PURE__*/_jsx(AsyncComponentErrorBoundary, {
      renderError: retry => /*#__PURE__*/_jsx(WidgetErrorRetryPanel, {
        inline: inline,
        isOpen: isOpen,
        mobile: mobile,
        widgetLocation: widgetLocation,
        onClose: onClose,
        retry: retry
      }),
      children: /*#__PURE__*/_jsx(CurrentViewContainer, {
        inline: inline,
        isOpen: isOpen,
        mobile: mobile,
        onOpenAnimationStarted: onOpenAnimationStarted,
        onCloseAnimationFinished: onCloseAnimationFinished,
        onOpenAnimationFinished: onOpenAnimationFinished,
        onCloseAnimationStarted: onCloseAnimationStarted,
        widgetLocation: widgetLocation,
        closeWidget: onClose
      })
    })
  }));
};
WidgetWindow.displayName = 'WidgetWindow';
export default WidgetWindow;